import { PageHeader } from "@/components/PageHelpers";
import { Card } from "@/components/ui/card";
import AIConciergeDrawer from "@/components/AIConciergeDrawer";
import { Sparkles } from "lucide-react";

export default function AIAvatarPage() {
  return (
    <div>
      <PageHeader eyebrow="AI · Claude Sonnet 4.5" title="AI Avatar Concierge" subtitle="A conversational face for your community." />
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-4">
        <Card className="lg:col-span-2 border-white/10 bg-card p-6 flex flex-col items-center">
          <div className="relative">
            <div className="absolute inset-0 rounded-full bg-indigo-500/30 blur-2xl" />
            <img
              src="https://images.pexels.com/photos/37148308/pexels-photo-37148308.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="AI Avatar"
              className="relative h-48 w-48 rounded-full object-cover border-2 border-indigo-500/60"
            />
          </div>
          <div className="mt-6 text-lg font-semibold font-display flex items-center gap-2">
            <Sparkles className="h-4 w-4 text-indigo-400" /> Nova — Community Concierge
          </div>
          <div className="text-xs text-zinc-500 mt-1 text-center max-w-xs">
            Nova greets residents in the lobby kiosk and can also be embedded in the resident app.
          </div>
        </Card>
        <Card className="lg:col-span-3 border-white/10 bg-card overflow-hidden h-[60vh] flex flex-col">
          <div className="flex-1 min-h-0">
            <AIConciergeDrawer agent="concierge" theme="dark" />
          </div>
        </Card>
      </div>
    </div>
  );
}
